"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon20Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon20Light = forwardRef_1.forwardRef('ArrowCUpIcon20Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M3.396 12.979a.5.5 0 0 1 0-.708l4.836-4.836a2.5 2.5 0 0 1 3.536 0l4.836 4.836a.5.5 0 1 1-.707.707L11.06 8.143a1.5 1.5 0 0 0-2.122 0l-4.835 4.835a.5.5 0 0 1-.708 0Z" })));
});
